import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { AccountLockingInfo } from '../../types/generated/Account.schema';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAccountGroupTraitsQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
}>;


export type GetAccountGroupTraitsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', delinquentAt?: string | null, delinquentGracePeriodExpiresAt?: string | null, id: string, managedBy?: Types.AccountManagementTypes | null, unpaidAt?: string | null, lockedAt?: string | null, lockReason?: Types.LockReason | null } | null };


export const GetAccountGroupTraits = /*#__PURE__*/ gql`
    query GetAccountGroupTraits($accountId: ID!) {
  account(accountId: $accountId) {
    ...AccountLockingInfo
    delinquentAt
    delinquentGracePeriodExpiresAt
    id
    managedBy
    unpaidAt
  }
}
    ${AccountLockingInfo}` as unknown as DocumentNode<GetAccountGroupTraitsQuery, GetAccountGroupTraitsQueryVariables>;

          

          export const useGetAccountGroupTraitsQuery = (options?:QueryHookOptions<GetAccountGroupTraitsQuery, GetAccountGroupTraitsQueryVariables>) => useQuery(GetAccountGroupTraits, options);

          

          export type GetAccountGroupTraitsQueryOptions = QueryHookOptions<GetAccountGroupTraitsQuery, GetAccountGroupTraitsQueryVariables>;

          

          export const useGetAccountGroupTraitsLazyQuery = (options?:LazyQueryHookOptions<GetAccountGroupTraitsQuery, GetAccountGroupTraitsQueryVariables>) => useLazyQuery(GetAccountGroupTraits, options);

          

          export type GetAccountGroupTraitsQueryResult = ReturnType<typeof useGetAccountGroupTraitsQuery>;

          
